import { useMemo } from 'react'
import { getDurationMeasureUnit, getMeasureUnitLabel } from 'components/pricing/LateFees/CreateEditLateFeesDialog/settings'
import T from 'T'

const useFormatLateFee = lateFee => {
  const {
    id,
    feeName,
    duration,
    pricingPeriod,
    startOffset,
    startOffsetUnit,
    feeRate,
    amountCents,
    amountPercent,
    businessLine,
    accountCount,
  } = lateFee || {}
  const isPricingPeriodOnce = useMemo(() => pricingPeriod === 'ONCE', [pricingPeriod])
  const durationMeasureUnit = useMemo(() => getDurationMeasureUnit(pricingPeriod), [pricingPeriod])
  const formattedDuration = useMemo(() => {
    if (pricingPeriod === 'ONCE') return T.NONE
    return duration === 0 ? T.INDEFINITE : `${duration} ${getMeasureUnitLabel(duration, durationMeasureUnit)}`
  }, [durationMeasureUnit, duration])
  const formattedStartDate = useMemo(() => {
    if (startOffset === 0) {
      return T.IMMEDIATE
    }

    const unit = startOffsetUnit ? `${startOffsetUnit}s` : durationMeasureUnit
    return `${startOffset} ${getMeasureUnitLabel(startOffset, unit)}`
  }, [startOffset, startOffsetUnit, durationMeasureUnit])
  return {
    id,
    feeName,
    formattedDuration,
    formattedStartDate,
    pricingPeriod,
    feeRate,
    amountCents,
    amountPercent,
    businessLine,
    accountCount,
    isPricingPeriodOnce,
  }
}

export default useFormatLateFee
